/** Route guards: gate on authentication and (optionally) role. */
import { Navigate, Outlet, useLocation } from 'react-router-dom';
import { useAuth } from '@/auth/AuthContext';
import type { Role } from '@/lib/types';
import { EmptyState } from './ui';

export function RequireAuth() {
  const { status } = useAuth();
  const location = useLocation();

  if (status === 'loading') {
    return (
      <div className="center-screen">
        <span className="spinner" style={{ width: 24, height: 24 }} />
      </div>
    );
  }
  if (status === 'anonymous') {
    return <Navigate to="/login" replace state={{ from: location.pathname }} />;
  }
  return <Outlet />;
}

export function RequireRole({ anyOf }: { anyOf: Role[] }) {
  const { hasRole } = useAuth();
  if (!hasRole(...anyOf)) {
    return (
      <div style={{ padding: 'var(--s7)' }}>
        <EmptyState title="Not authorized" hint={`This area requires the ${anyOf.join(' or ')} role.`} />
      </div>
    );
  }
  return <Outlet />;
}
